type Dimension = number | string | undefined;

/** Scales a numeric value, preserving 'px' suffix if present */
const scale = (value: Dimension, factor: number): Dimension => {
  if (value === undefined) return undefined;
  if (typeof value === 'number') return value * factor;
  const num = parseFloat(value);
  if (isNaN(num)) return value;
  return value.endsWith('px') ? `${num * factor}px` : num * factor;
};

export function calculateProportionalDimensions(width: Dimension, height: Dimension, defaultWidth: number, defaultHeight: number) {
  const aspectRatio = defaultWidth / defaultHeight;

  if (!width && !height) return { width: defaultWidth, height: defaultHeight };
  if (width && !height) return { width, height: scale(width, 1 / aspectRatio) };
  if (!width && height) return { width: scale(height, aspectRatio), height };
  return { width, height };
}
